import React from "react";
import styled from "styled-components";
import { ThemedSpan } from "../../../utilities";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Container = styled.div`
    background-color: #f5f5f5;
    display: flex;
    justify-content: center;
    position: sticky;
    top: 0;
    z-index: 20;
`;

const RestrictedRecipientMessage = () => (
    <Container>
        <p className="m-0 p-3">
            <ThemedSpan variant="warning" className="me-1">
                <FontAwesomeIcon icon={['fas', 'triangle-exclamation']} />
            </ThemedSpan>
            <ThemedSpan variant="warning">
                One of the recipients selected is marked as a "restricted" email contact.
            </ThemedSpan>
        </p>
    </Container>
);

export default RestrictedRecipientMessage;